<template>
  <div style="position: relative" :class="prefixCls">
    <Popover
      placement="bottomLeft"
      overlayClassName="msg-Popover"
      title=""
      trigger="hover"
      :overlayClassName="`${prefixCls}__overlay`"
    >
      <Badge
        :offset="badgeOffset"
        :overflowCount="99"
        :count="store.msgTotal"
        :numberStyle="numberStyle"
      >
        <div :style="getTechnologyFrameTextColor" :class="`${prefixCls}-text`" v-if="isFrameType">{{ t('layout.header.message') }}</div>
        <BellOutlined v-else />
      </Badge>

      <template #content>
        <div class="contentBody">
          <div style="display: flex; justify-content: space-between">
            <div style="line-height: 33px; font-size: 14px; font-weight: 500" @click="handleClick">{{
                t('layout.header.未读消息')
              }}</div>
            <div @click="openMsgPage"
            ><Button type="link">{{ t('layout.header.更多') }} <DoubleRightOutlined /> </Button
            ></div>
          </div>
          <Tabs v-if="msgData.length !== 0">
            <template v-for="item in msgData" :key="item.type">
              <TabPane>
                <template #tab>
                  {{ t(item.name) }}
                  <span v-if="item.list.length !== 0">({{ item.list.length }})</span>
                </template>
                <NoticeList :tabName="item.name" :list="item.list" @title-click="onNoticeClick" />
              </TabPane>
            </template>
          </Tabs>
          <div class="nodedata__class" v-else>
            <div>
              <img style="width: 80px; height: 80px" :src="nodeDataUrl" alt="" />
              <p style="text-align: center; color: #999">{{ t('layout.header.暂无消息') }}</p>
            </div>
          </div>
        </div>
      </template>
    </Popover>

    <!-- 消息详情弹框 -->
    <msg-detail-win :winTemConfig="winTemConfig" v-model:visible="msgDetailFlag"/>
    <news-list v-show="false" ref="newsListRef"/>
  </div>
</template>
<script lang="ts">
  import NewsList from '@/gateway-main-base/newsList/index.vue';
  import SysConfigUtils from '@/utils/sysConfigUtils';
  import MsgDetailWin from "@/layouts/default/header/components/notify/msgComs/msg-detail-win.vue";
  import msgdetail from './msgdetail.vue';
  import { msgStore } from '@/store/modules/msgStore';
  import { defineComponent, onMounted, ref } from 'vue';
  import { Popover, Tabs, Badge, Button, Drawer, Modal } from 'ant-design-vue';
  import { BellOutlined, DoubleRightOutlined } from '@ant-design/icons-vue';
  import NoticeList from './NoticeList.vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useRouter } from 'vue-router';
  import { msgHooks } from '../hooks/msgHooks';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';
  import {useMsgHook} from "@/layouts/default/header/components/notify/msgComs/useMsgHook";
  import {useMsgDealHooks} from '@/main-page/userDefCtl/hooks/useMsgDealHooks';
  import {StorageUtils} from "xmgoing-utils";
  import { useAppFrame } from '@/hooks/useAppFrame';

  export default defineComponent({
    components: {
      msgdetail,
      NewsList,
      MsgDetailWin,
      Popover,
      BellOutlined,
      Button,
      Tabs,
      DoubleRightOutlined,
      TabPane: Tabs.TabPane,
      Badge,
      NoticeList,
      Drawer,
      Modal,
    },
    props:{
      curLayout:{}
    },
    setup(props) {
      const curLayout=props.curLayout;
      const { t } = useI18n();
      const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();
      onMounted(() => {
        window.addEventListener('message', getInBoxMessage);
        store.getReadMsg();
        msgHooks();
      });

      const getInBoxMessage = (messageEvent) => {
        if (messageEvent.data.action === 'update-inBoxMessage') {
          store.getReadMsg();
          msgHooks();
        }
      };
      const router = useRouter();

      const winTemConfig=ref({});
      const msgDetailFlag = ref(false);
      const store = msgStore();
      const { msgData } = storeToRefs(store);
      const { prefixCls } = useDesign('header-notify');

      const newsListRef=ref(null);
      //消息cook
      const {onNoticeClick,initMsgViewModel}=useMsgHook({store,router,winTemConfig,msgDetailFlag},newsListRef);

      const {openMsgDeal,openSubPageDrawer}=useMsgDealHooks();
      //注册成全局函数
      if(window.appObj){
        window.appObj.openMsgDeal=openMsgDeal;
        window.appObj.openSubPageDrawer=openSubPageDrawer;
      }
      const badgeOffset = computed(() => {
        if (isFrameType.value) {
          return [-1, -8];
        }
        if(curLayout==='environmental'){
          return [2, 4];
        }else{
          return [-11, 12];
        }
      });

      const numberStyle = computed(() => {
        const count = store.msgTotal || 0;
        if (count < 10) {
          return { padding: '0', minWidth: '16px', width: '16px' };
        }
        return { padding: '0 4px', minWidth: '16px' };
      });

      function getContainer() {
        return document.body;
      }

      const openMsgPage = () => {
        StorageUtils.addSessionItem('curMenuName', '消息中心');
        // 更多 → 流程待办中心，activeKey 指定默认激活的左侧导航节点（工作通知）
        router.push({ path: '/flowList/waitDeal', query: { activeKey: 'workNotice' } });
      };
      const nodeDataUrl = computed(() => {
        return SysConfigUtils.staticUrl + '/static/nodeData.svg';
      });

      const handleClick = () => {
        // 在这里编写点击事件的逻辑
        openMsgPage();
      };

      initMsgViewModel();
      return {
        newsListRef,
        curLayout,
        handleClick,
        winTemConfig,
        openMsgPage,
        prefixCls,
        msgData,
        onNoticeClick,
        numberStyle,
        store,
        msgDetailFlag,
        getContainer,
        nodeDataUrl,
        badgeOffset,
        t,
        isFrameType,
        getTechnologyFrameTextColor,
      };
    },
  });
</script>
<style lang="less">

.contentBody{
  width:420px;
}
  .msg-Popover.vben-header-notify__overlay{
    width:420px;
  }
  @prefix-cls: ~'@{namespace}-header-notify';


  .nodedata__class {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .@{prefix-cls} {
    padding-top: 2px;

    .ant-badge-count{
      min-width: 14px;
      height: 14px;
      width: 14px;
      line-height: 14px;
      padding: 0px 12px !important;
      .ant-scroll-number-only{
        position: relative;
        left:-6px;
      }
    }

    &-text {
      font-size: 14px;
      color: #FFF;
    }

    &__overlay {
      // max-width: 360px;
      width: 380px;
    }

    .ant-tabs-content {
      width: 300px;
    }

    .ant-badge {
      font-size: 18px;

      .ant-badge-multiple-words {
        padding: 0 4px;
      }

      svg {
        width: 0.9em;
      }
    }
  }

</style>
